import { Box, TextField } from '@mui/material';
import { RoiField } from './roiFields';

export interface RoiFieldGridProps {
  fields: RoiField[];
  values: Record<string, number>;
  canEdit: boolean;
  onChange: (key: string, value: string) => void;
  onBlur: () => void;
}

export const RoiFieldGrid = ({ fields, values, canEdit, onChange, onBlur }: RoiFieldGridProps) => (
  <Box className="grid grid-cols-2 md:grid-cols-3 gap-3">
    {fields.map((field) => (
      <TextField
        key={field.key}
        label={field.label}
        type="number"
        size="small"
        value={values[field.key] || ''}
        onChange={(e) => onChange(field.key, e.target.value)}
        onBlur={onBlur}
        disabled={!canEdit}
        fullWidth
      />
    ))}
  </Box>
);
